import styled from 'styled-components';
import { getToken } from '@optimus-web/common';

interface DisabledProps {
    condition?: boolean;
}

export const DisabledComponent = styled.div<DisabledProps>`
    opacity: ${({ condition, theme }) =>
        condition ? getToken('opacity400')({ theme }) : getToken('opacity1000')({ theme })};
`;
